export default {
  NODE_ENV: import.meta.env.VITE_HOST_ENV || 'development',
  REACT_APP_BASE_API_URL: import.meta.env.VITE_BASE_API_URL,
  APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.01.00',
  GOOGLE_KEY: import.meta.env.VITE_GOOGLE_KEY,
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
}
